const templateUrl = require('./../views/partials/loading-popup.html');

function loadingPopupDirective($timeout, $rootScope) {
  "ngInject";
  return {
    restrict: 'EA',
    scope: {},
    replace: true,
    templateUrl,
    link: function(scope, el, attrs) {

      scope.showPopup = false;

      var showPopup = function() {
        scope.showPopup = true;
      };

      var hidePopup = function() {
        scope.showPopup = false;
      };

      $rootScope.$on('show:loadingPopup', showPopup);

      $rootScope.$on('hide:loadingPopup', hidePopup);

      $rootScope.$on('$stateChangeSuccess', hidePopup);
    }
  };
}

export default loadingPopupDirective;



// WEBPACK FOOTER //
// ./js/containers/users/directives/loadingPopup.js